import React from "react";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { StyledTabsBody, StyledTabsHead } from "../../../styles/styledTabs";
import TabPanel from "../../../elements/tab/materialTabPanel";
import WalletPaymentsContainer from "./payments/WalletPaymentsContainer";
import WalletPayoutsContainer from "./payouts/WalletPayoutsContainer";

const DEFAULT_TAB = "payments";

const WalletTabContainer = ({ match, t }) => {
  const history = useHistory();

  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "payments": {
        return 0;
      }
      case "payouts": {
        return 1;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledContentWrapper height="auto">
      <StyledTabsHead
        className="tab-head"
        orientation="horizontal"
      >
        <Tabs
          value={queryParams?.currentTab ?? DEFAULT_TAB}
          indicatorColor="secondary"
          onChange={handleChange}
          orientation="horizontal"
          className="tab-head-buttons"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label={t("details.tabs.payments")} value="payments" />
          <Tab label={t("details.tabs.payouts")} value="payouts" />
        </Tabs>
      </StyledTabsHead>
      <StyledTabsBody className="tab-body">
        <TabPanel
          value={tabValue}
          index={0}
        >
          <WalletPaymentsContainer match={match} />
        </TabPanel>
        <TabPanel
          value={tabValue}
          index={1}
        >
          <WalletPayoutsContainer match={match} />
        </TabPanel>
      </StyledTabsBody>
    </StyledContentWrapper>
  );
};

export default WalletTabContainer;